L.mapbox.accessToken = bookedby.staticData.mapboxAccessKey;
module.exports = L;